<template>
  <div class="tally-book">
    <van-nav-bar title="记账本" left-arrow fixed @click-left="onClickLeft" />
    <div class="main">
      <div class="bar-fixed">
        <div class="book-top wh-flex-between">
          <div class="top-left" @click="dateShow=true">
            <span class="top-year">{{ curData.year }}年</span>
            <div class="top-month">
              <span>{{ curData.month }}</span>
              <span>月</span>
              <van-icon name="play" class="month-icon" />
            </div>
          </div>
          <div v-show="barNum===1" class="top-right">
            <div class="expend">
              <span>支出(元)</span>
              <span>{{ account.payCount || '0.00' }}</span>
            </div>
            <div class="income">
              <span>收入(元)</span>
              <span>{{ account.incomeCount || '0.00' }}</span>
            </div>
          </div>
          <div v-show="barNum===2" class="top-right">
            <div class="expend">
              <span>总{{ rankStatus==='out'?'支出':'收入' }}({{ total.count || '0' }}笔)</span>
              <span>{{ total.money || '0.00' }}</span>
            </div>
            <div class="income">
              <div class="btn" :class="rankStatus==='out'?'':'active-btn'" @click="rankList('out')">
                支出
              </div>
              <div class="btn" :class="rankStatus==='in'?'':'active-btn'" @click="rankList('in')">
                收入
              </div>
            </div>
          </div>
        </div>
        <div class="top-bar wh-flex-between">
          <span :class="{'active-item': barNum===1}" class="bar-item" @click="topBarFn(1)">明细</span>
          <span :class="{'active-item': barNum===2}" class="bar-item" @click="topBarFn(2)">类别报表</span>
        </div>
      </div>
      <div v-if="barNum===1" class="bar-content">
        <wh-mobile-list ref="listData" height="540px" data-src="/api/getTallyBook" :extra-params="extraParams">
          <template #default="{list}">
            <van-swipe-cell v-for="(item,index) in list" :key="index">
              <div class="content-item" @click="editTallyBook(item)">
                <div class="bar-content-title wh-flex-between">
                  <div class="left">
                    {{ formatTime(item.date,'DD') }}日-星期{{ weekList[formatTime(item.date,'d')] }}
                  </div>
                  <div class="right">
                    <span>支出：{{ item.property==='支出'?item.money:0.00 }}</span>
                    <span>收入：{{ item.property==='收入'?item.money:0.00 }}</span>
                  </div>
                </div>
                <div class="icon-style wh-flex-between">
                  <div class="wh-flex-start">
                    <svg-icon :icon-class="getSvg(item.type)" class="svg-icon" :class="item.property==='收入'?'income':'expend'" />
                    <div style="padding-left:6px">
                      {{ item.type }} - <span style="color:#999">{{ item.note }}</span>
                    </div>
                  </div>
                  <!--        <span>{{ item.property==='收入'?'+':'-' }}{{ item.money }}</span>-->
                </div>
              </div>
              <template #right>
                <van-button square text="删除" type="danger" style="height:100%" @click.native="deleteTallyBook(item)" />
              </template>
            </van-swipe-cell>
          </template>
        </wh-mobile-list>
      </div>
      <div v-else class="bar-content">
        <div class="rank-title">
          {{ rankStatus==='out'?'支出':'收入' }}排行榜
        </div>
        <div v-for="(i,key) in reportList" :key="key" class="wh-flex-between rank">
          <svg-icon :icon-class="getSvg(i.type)" class="svg-icon" :style="{backgroundColor:rankStatus==='out'?'#f60':'#88cc43'}" />
          <div class="process-list">
            <div class="top">
              <span>{{ i.type }}</span>
              <span>￥{{ i.money }}</span>
            </div>
            <div class="slider">
              <van-slider :value="(i.money/reportTotal)*100" active-color="#ee0a24" bar-height="4px">
                <template #button>
                  <div class="custom-button">
                    {{ ((i.money/reportTotal)*100).toFixed(2) }}%
                  </div>
                </template>
              </van-slider>
            </div>
          </div>
        </div>
      </div>
      <div v-show="barNum===1" class="bar-btn">
        <van-button round type="info" style="width:260px;background:#65fda3;border:none" @click="addTallyBook">
          + 记一笔
        </van-button>
      </div>
    </div>
    <van-popup
      v-model="dateShow"
      :style="{height: '40%'}"
      data-name="记账日期"
      position="bottom"
    >
      <van-datetime-picker
        v-model="startDate"
        :formatter="formatter"
        type="year-month"
        class="date-txt-color"
        @cancel="dateShow=false"
        @confirm="timeSureFn"
      />
    </van-popup>
    <tally-book-popup
      :visible.sync="popup.book.visible"
      :form-type="popup.book.formType"
      :init-form-data="popup.book.initFormData"
      @submitFormSuccess="submitFormSuccessFn"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayjs from 'dayjs'
import TallyBookPopup from '@/views/More/components/TallyBookPopup'
import { getSvg } from '@/utils/tool'
import { formatTime } from '@/utils/convert/convertTime'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList.vue'
export default {
  components: { TallyBookPopup, WhMobileList },
  data() {
    return {
      barNum: 1,
      dateShow: false,
      weekList: ['日', '一', '二', '三', '四', '五', '六'],
      startDate: new Date(),
      curData: {
        date: this.formatTime(new Date(), 'YYYY-MM'),
        year: this.formatTime(new Date(), 'YYYY'),
        month: this.formatTime(new Date(), 'MM'),
        day: this.formatTime(new Date(), 'DD')
      },
      popup: {
        book: {
          visible: false,
          formType: 'create',
          initFormData: {}
        }
      },
      reportList: [],
      reportTotal: 0,
      account: {
        payCount: 0,
        incomeCount: 0
      },
      total: {
        count: 0,
        money: 0
      },
      resData: {
        incomeCount: undefined,
        payedCount: undefined
      },
      rankStatus: 'out'
    }
  },
  computed: {
    extraParams() {
      return {
        property: '',
        searchDate: this.formatTime(this.curData.date, 'YYYY-MM')
      }
    }
  },
  mounted() {
    this.getReport()
  },
  methods: {
    getSvg,
    formatTime,
    deleteTallyBook(item) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        api.deleteTallyBook({ id: item.id }).then(res => {
          this.$refs.listData.onRefresh()
          this.$toast.success(res.msg)
        })
      }).catch(() => {})
    },
    getReport() {
      const params = {
        beginDate: this.formatTime(this.startDate, 'YYYY-MM-01 00:00:00'),
        endDate: dayjs(this.startDate).add(1, 'month').format('YYYY-MM-01 00:00:00')
      }
      this.resData = {
        incomeCount: undefined,
        payedCount: undefined
      }
      this.account = {
        payCount: 0,
        incomeCount: 0
      }
      api.countTallyBook(params).then(res => {
        if (res.data.propertyCount) {
          res.data.propertyCount.map(i => {
            if (i.property === '收入') {
              this.account.incomeCount = i.money
            }
            if (i.property === '支出') {
              this.account.payCount = i.money
            }
          })
        }
        this.resData = {
          incomeCount: res.data.incomeCount,
          payedCount: res.data.payedCount
        }
        this.rankList(this.rankStatus)
      })
    },
    rankList(i) {
      this.rankStatus = i
      this.total = {
        count: 0,
        money: 0
      }
      this.reportTotal = 0
      if (i === 'out') {
        this.total.count = (this.resData.payedCount || []).length;
        (this.resData.payedCount || []).map(item => {
          this.total.money += item.money
        })
        this.reportList = this.resData.payedCount || []
        if (this.reportList.length) {
          this.reportList.map(i => {
            this.reportTotal += i.money
          })
        }
      } else {
        this.total.count = (this.resData.incomeCount || []).length;
        (this.resData.incomeCount || []).map(item => {
          this.total.money += item.money
        })
        this.reportList = this.resData.incomeCount || []
        if (this.reportList.length) {
          this.reportList.map(i => {
            this.reportTotal += i.money
          })
        }
      }
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    editTallyBook(i) {
      this.popup.book.formType = 'edit'
      this.popup.book.visible = true
      this.popup.book.initFormData = { ...i }
    },
    timeSureFn() {
      this.curData = {
        date: this.formatTime(this.startDate, 'YYYY-MM'),
        year: this.formatTime(this.startDate, 'YYYY'),
        month: this.formatTime(this.startDate, 'MM'),
        day: this.formatTime(this.startDate, 'DD')
      }
      this.getReport()
      this.dateShow = false
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    topBarFn(i) {
      this.barNum = i
    },
    submitFormSuccessFn() {
      this.$refs.listData.onRefresh()
      this.getReport()
    },
    addTallyBook() {
      this.popup.book.formType = 'create'
      this.popup.book.visible = true
    }
  }
}
</script>
<style lang="less" scoped>
.tally-book{
   .custom-button {
    width: 50px;
    color: #fff;
    font-size: 10px;
    line-height: 18px;
    text-align: center;
    background-color: #ee0a24;
    border-radius: 100px;
  }
  /deep/ .van-nav-bar{
    background-color: #272A3B;
    &:after{
      border: none;
    }
  }
  /deep/.van-nav-bar__title,/deep/ .van-nav-bar .van-icon{
    color: #fff;
  }
  .main{
    position: relative;
    .bar-fixed{
      z-index: 1;
      width: 100%;
      position: fixed;
      top: 46px;
      background-color: #272A3B;
      .book-top{
        height: 75px;
        width: 100%;
        color: #eee;
        margin: 10px 0;
        .top-left{
          width: 112px;
          display: flex;
          height: 75px;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          border-right: 1px dashed #fff;
          .top-year{
            font-size: 16px;
          }
          .top-month{
            &>span:first-child{
              font-size: 36px;
            }
            &>.month-icon{
              transform: rotate(90deg);
            }
          }
        }
        .top-right{
          display: flex;
          justify-content: space-around;
          width: calc(100% - 75px);
          .income,.expend{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            height: 60px;
            justify-content: space-between;
          }
         .btn{
          width: 46px;
          height: 25px;
          background-color: #fff;
          color: #272A3B;
          line-height: 25px;
          border-radius: 4px;
          text-align: center;
          font-size: 14px;
        }
          .active-btn{
            border: 1px solid #fff;
            color: #fff;
            background-color: #272A3B;
          }
        }
      }
      .top-bar{
        width: 100%;
        background-color: #fff;
       .bar-item{
          background-color: #5b5d69;
          flex: 1;
          padding:10px;
          color: #fff;
          text-align: center;
        }
        .active-item{
          background-color: #fff;
          color: #5b5d69;
        }
      }
    }
    .bar-content{
      margin-top: 190px;
      .content-item{
        margin-bottom: 16px;
        padding: 0 10px;
        .bar-content-title{
          padding: 14px 0;
          font-size: 12px;
          color: #999;
          .right{
            >span:first-child{
              margin-right: 20px;
            }
          }
        }
        .icon-style{
          margin-bottom: 10px;
          font-size: 16px;
          color: #333;
          .svg-icon{
            width: 24px;
            height: 24px;
            padding: 6px;
            border-radius: 50%;
            color: #fff;
          }
          .income{
            background-color: #88cc43;
          }
          .expend{
            background-color: #f60;
          }
        }
      }
      .rank-title{
        padding: 4px 6px;
      }
      .rank{
        padding: 10px;
        .svg-icon{
            width: 24px;
            height: 24px;
            padding: 6px;
            border-radius: 50%;
            color: #fff;
        }
        .process-list{
          width: calc(100% - 60px);
          .top{
            padding-bottom: 14px;
            font-size: 12px;
            color: #222;
            >span:last-child{
              color: #999;
            }
          }
        }
        .slider{
          padding: 0 20px 0 0;
        }
      }
    }
    .bar-btn{
      position: fixed;
      bottom: 20px;
      left: calc(50% - 130px);
    }
  }
}
</style>
